import React from "react";
import './submitContent.scss';
import pdfIcon from "../../../../../assets/icons/pdf-chapter-icon.svg";
import videoIcon from "../../../../../assets/icons/video-chapter-icon.svg";
import ToggleSwitch from "../../../../../shared/components/ToggleSwitch";
import removeIcon from "../../../../../assets/icons/close-red-icon.svg";
import { Input } from 'antd';

const SubmitContent = (props:any) => {

    const {selectedContents, setSelectedContents} = props;

    const handleContentRemove = (contentId:number) =>{
        let filterContent = selectedContents.filter((content:any) => content.id !== contentId)
        setSelectedContents([...filterContent])
    }

    const handleContentToggle = (contentId:string) => {
        setSelectedContents(selectedContents.map((content:any) =>
            content.id === contentId ? { ...content, isActive: !content.isActive } : content
        ));
    }
    const handleTitleChange = (e:any,contentId:string) => {
        setSelectedContents(selectedContents.map((content:any) =>
            content.id === contentId ? { ...content, displayTitle: e.target.value } : content
        ));
    }

    return(
        <div className="add-content__selection">
            {selectedContents.map((content:any,i:number)=>
                <div key={i}>
                    <div className="add-content__card submit-content__card">
                        <div>
                            <div className="add-content__card__image">
                                <img src={content?.displayPictureUrl} alt=''/>
                            </div>
                            <div className="add-content__info">
                                <div className="add-content__detail submit-content__detail">
                                    <img src={content?.contentType === 'pdf' ? pdfIcon : videoIcon} alt=''/>
                                    {content?.contentLength} {content?.contentType === 'pdf'? ' pages' : ' mins'}
                                </div>
                                <div className="add-content__toggle">
                                    <ToggleSwitch checked={content?.isActive}
                                                  handleChange={()=>handleContentToggle(content.id)}
                                    />
                                </div>
                                <div className="add-content__remove"
                                     onClick={()=>handleContentRemove(content.id)}
                                >
                                    <img src={removeIcon} alt=''/>
                                </div>
                            </div>
                        </div>
                        <div className="input-field">
                            <div className="submit-form__label">Display title</div>
                            <Input type="text"
                                   name="displayTitle"
                                   value={content?.displayTitle}
                                   defaultValue={''}
                                   placeholder="Enter display title"
                                   onChange={(e)=>handleTitleChange(e,content.id)}
                            />
                        </div>
                    </div>
                </div>
            )}
            </div>
    )
}

export default SubmitContent;
